export default __webpack_public_path__ + "static/media/fossil2.a05e0b8c.png";